import { IconButton, IconButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export type StyledNoteButtonAdditionalProps = {
  isExpanded: boolean;
  hasContent: boolean;
};

export const StyledNoteButton = styled(IconButton)<
  IconButtonProps & StyledNoteButtonAdditionalProps
>(({ theme, isExpanded, hasContent }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.text.primary,
  margin: 0,
  padding: 8,
  background: theme.palette.grey[200],
  borderRadius: "100%",
  minWidth: 32,
  minHeight: 32,
  maxWidth: 32,
  maxHeight: 32,
  "& .MuiSvgIcon-root": {
    fontSize: 16,
  },
  "&:hover": {
    background: theme.palette.grey[500],
  },
  ...(isExpanded && {
    background: theme.palette.common.black,
    color: theme.palette.common.white,
  }),
  ...(hasContent &&
    !isExpanded && {
      background: "#DDDEFB",
      color: theme.palette.custom.purple[400],
      // theme.palette.secondary.main,
      border: `2px solid ${theme.palette.secondary.main}`,
      "&::after": {
        content: '""',
        position: "absolute",
        top: -4,
        left: -4,
        right: -4,
        bottom: -4,
        border: `2px solid ${theme.palette.custom.purple[400]}`,
        borderRadius: "100%",
        pointerEvents: "none",
      },
    }),
}));
